import React from 'react';
import { Box, VStack, Heading, Text, Grid, GridItem, Button, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { getDecodedToken } from '../../services/Token';

interface MenuItem {
  title: string;
  description: string;
  path: string;
  color: string;
}

const DashboardPage = () => {
  const navigate = useNavigate();
  const decoded = getDecodedToken();
  const bgCard = useColorModeValue('white', 'gray.700');

  if (!decoded) {
    return (
      <Box p={5} bg="rgba(2, 54, 176, 0.9)" minH="100vh">
        <Heading color="white">Acceso denegado</Heading>
      </Box>
    );
  }

  const getSuperUserMenuItems = (): MenuItem[] => [
    {
      title: 'Instituciones',
      description: 'Gestiona todas las instituciones del sistema',
      path: '/dashboard/instituciones',
      color: 'blue',
    },
    {
      title: 'Administradores',
      description: 'Administra los usuarios del sistema',
      path: '/dashboard/administradores',
      color: 'purple',
    },
    {
      title: 'Eventos',
      description: 'Gestiona los eventos del sistema',
      path: '/dashboard/eventos',
      color: 'green',
    },
    {
      title: 'Noticias',
      description: 'Gestiona las noticias del la pagina',
      path: '/dashboard/noticias',
      color: 'pink',
    },
  ];

  const getAdminMenuItems = (): MenuItem[] => [
    {
      title: 'Carreras',
      description: 'Gestiona las carreras de tu institución',
      path: '/dashboard/carreras',
      color: 'blue',
    },
    {
      title: 'Eventos',
      description: 'Gestiona los eventos de tu institución',
      path: '/dashboard/eventos',
      color: 'green',
    },
  ];

  const menuItems = decoded.rol_id === 1 ? getSuperUserMenuItems() : getAdminMenuItems();

  return (
    <Box bg="rgba(2, 54, 176, 0.9)" minH="100vh" p={5}>
      <VStack spacing={8} maxW="1200px" mx="auto" align="stretch">
        <Box textAlign="center">
          <Heading color="white" size="2xl" mb={2}>
            Panel de Control
          </Heading>
          <Text color="whiteAlpha.800">
            {decoded.rol_id === 1 ? 'Bienvenido SuperUsuario' : 'Bienvenido Administrador'}
          </Text>
        </Box>

        <Grid
          templateColumns={{ base: '1fr', sm: '1fr', md: '2fr', lg: '2fr' }}
          gap={6}
          mt={8}
        >
          {menuItems.map((item) => (
            <GridItem key={item.path}>
              <Box
                bg={bgCard}
                p={6}
                borderRadius="lg"
                shadow="md"
                borderLeft={`4px solid`}
                borderLeftColor={`${item.color}.500`}
                transition="all 0.2s"
                _hover={{
                  shadow: 'lg',
                  transform: 'translateY(-4px)',
                }}
              >
                <Heading size="md" mb={2} color={`${item.color}.600`}>
                  {item.title}
                </Heading>
                <Text mb={4} color="gray.600">
                  {item.description}
                </Text>
                <Button
                  colorScheme={item.color}
                  size="sm"
                  onClick={() => navigate(item.path)}
                  width="full"
                >
                  Acceder
                </Button>
              </Box>
            </GridItem>
          ))}
        </Grid>
      </VStack>
    </Box>
  );
};

export default DashboardPage;
